// extracted by mini-css-extract-plugin
module.exports = {"container":"OffPlatformSharing_container__gJ1bL","icon":"OffPlatformSharing_icon__L9Aen","iconWrapper":"OffPlatformSharing_iconWrapper__At_GL"};